import { ResponsePageable } from './../../model/cliente/pageable/responsePageable.model';
import { ModuloModel } from './../../model/endereco/modulo.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ModuloService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  adicionarModulo(modulo: ModuloModel): Observable<ModuloModel> {
    return this.httpClient.post<ModuloModel>(this.apiURL + '/adicionar-modulo', modulo, this.httpOptions);
  }

  getModulos(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/listar-modulos', this.httpOptions);
  }

  getModulosList(): Observable<Array<ModuloModel>>{
    return this.httpClient.get<Array<ModuloModel>>(this.apiURL + '/listar-modulos-list', this.httpOptions);
  }

  getPageModulo(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/listar-modulos?page=${page}&size=${size}`, this.httpOptions);
  }

  deleteModulo(id: number) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + `/apagar-modulo/${id}`, { headers, responseType: 'text'});
  }

  editarModulo(modulo: ModuloModel): Observable<ModuloModel> {
    return this.httpClient.put<ModuloModel>(this.apiURL + '/editar-modulo', modulo, this.httpOptions);
  }

  getModuloByArmazem(armazemId: Number): Observable<ModuloModel[]> {
    return this.httpClient.get<ModuloModel[]>(this.apiURL + `/listar-modulo-armazem/${armazemId}`, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/endereco/modulo.service.ts